<template>
  <div
    v-click-outside="onClickOutside"
    class="d-flex flex-column"
    style="gap: 5px"
  >
    <z-selected-values-input
      :input-placeholder="inputPlaceholder"
      :value="appliedValues"
      :input-value="inputValue"
      :show-all.sync="showAll"
      :max-displayed-values="maxDisplayedValues"
      @click:additional-items="$emit('click:additional-items')"
      @focus="onFocus"
      @keyup.enter="onSelect"
      @click:remove="onRemoveChip"
      @input="$emit('update:input-value', $event)"
    ></z-selected-values-input>

    <v-expand-transition>
      <div v-if="shouldShowCard">
        <z-card width="100%">
          <template #content>
            <v-list class="pa-0" dense nav>
              <z-exclusion-list
                v-if="showExclusion"
                :items="[{text: inputValue, value: inputValue}]"
                @include="onClickInclude"
                @exclude="onClickExclude"
              ></z-exclusion-list>

              <v-list-item v-else @click="onSelect">
                <v-list-item-content>
                  {{ inputValue }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </z-card>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'ZSelectableSearchInput',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    inputValue: {
      type: String,
      default: '',
    },
    showExclusion: {
      type: Boolean,
      default: false,
    },
    maxDisplayedValues: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      shouldShowCard: false,
      showAll: false,
    }
  },

  computed: {
    appliedValues() {
      if (this.showExclusion) {
        return this.value.map((v) => ({
          ...v,
          color: v.type === 'include' ? 'var(--primary)' : 'var(--red-400)',
        }))
      }

      return this.value
    },
  },

  watch: {
    inputValue(val) {
      this.shouldShowCard = !!val
    },

    shouldShowCard(val) {
      this.$emit('update:show-card', val)
    },
  },

  methods: {
    onRemoveChip(item) {
      this.$emit(
        'update:value',
        this.value.filter((v) => v.value !== item.value)
      )
    },

    onSelect() {
      if (!this.inputValue) return

      const emittedItems = this.showExclusion
        ? [
            ...this.value,
            {value: this.inputValue, text: this.inputValue, type: 'include'},
          ]
        : [...this.value, {value: this.inputValue, text: this.inputValue}]

      this.$emit('update:value', emittedItems)
      this.$emit('update:input-value', '')
    },

    onClickInclude(item) {
      this.$emit('update:value', [
        ...this.value,
        {value: item.value, text: item.text, type: 'include'},
      ])
      this.$emit('update:input-value', '')
    },

    onClickExclude(item) {
      this.$emit('update:value', [
        ...this.value,
        {value: item.value, text: item.text, type: 'exclude'},
      ])
      this.$emit('update:input-value', '')
    },

    onClickOutside() {
      this.shouldShowCard = false
      this.showAll = false
    },

    onFocus() {
      if (this.inputValue) {
        this.shouldShowCard = true
      }
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-list-item) {
  height: 30px !important;
  min-height: 30px !important;
}
</style>
